/*
Set up Equalizer to add vertical-center from data-attribute
*/

jQuery( '[data-equalize-vertical-center]' ).on( 'postequalized.zf.equalizer', function(){
    var targetClass = '.' + jQuery( this ).data( 'equalize-vertical-center' );
    jQuery( this ).find( targetClass ).addClass( 'vertical-center-large' );
});

// Hamburger
jQuery( 'body' ).on( 'closed.zf.offcanvas', function(){
    jQuery( '#menu-hamburger' ).removeClass( 'is-active' );
});

var setGridItemHeight = function(){
    var windowHeight = jQuery( window ).height(),
        firstGridItem = jQuery( '.grid-item-hero' ),
        headerHeight = jQuery( '.header' ).offset().top + jQuery( '.header' ).height(),
        maxHeight = windowHeight - headerHeight;
    if( maxHeight > 400 && Foundation.MediaQuery.atLeast('medium') ){
        firstGridItem.css( 'max-height', maxHeight ).css( 'padding-bottom', maxHeight );
    }else{
        firstGridItem.css( 'max-height', '' ).css( 'padding-bottom', '' );
    }
};

// Add Print Button
var addPrintButton = function() {

    jQuery( '.social-share' ).append( jQuery('<button class="print-button"><span class="icon-printer"></span></button>') );

    jQuery( '.social-share' ).on( 'click', '.print-button', function() {
        window.print();
    });
};

// Hero background interchange
var backgroundInterchange = function (targetElementSelector, newSize) {
    var targetElement = jQuery( targetElementSelector );

    if( targetElement.data( 'mobile-background' ) && targetElement.data( 'desktop-background' ) ){
        if( Foundation.MediaQuery.is( 'xlarge' ) ) {
            targetElement.css('background-image', 'url(' + targetElement.data( 'desktop-background' ) + ')');
        }else{
            targetElement.css('background-image', 'url(' + targetElement.data( 'mobile-background' ) + ')');
        }
    }
};

var setupPage = function(){
    setGridItemHeight();
    addPrintButton();

    var recipeRibbon = jQuery( '.recipe-ribbon' );
    if( recipeRibbon.length ){
        recipeRibbon.flickity({ // options
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            groupCells: true,
            pageDots: false,
        });
    }

    var header = jQuery( '.header' );
    header.height( header.height() );

    jQuery( '#top-bar-menu' ).addClass( 'sticky' );

    backgroundInterchange( '.grid-item-hero' );

    jQuery( window ).on( 'changed.zf.mediaquery', function( event, newSize, oldSize ){
        // newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint
        backgroundInterchange( '.grid-item-hero' );
    });

    jQuery( '.variety-menu-item a' ).on( 'click', function() {
        var target = jQuery( this ).attr("href"),
            header = jQuery( '.header' );

        if( jQuery( target ).length > 0 ){
            event.preventDefault();

            jQuery('html, body').animate({
                scrollTop: jQuery( target ).offset().top - header.height() - 80 // Variety top - height of header - row padding
            }, 200);
        }
    });
};

var didScroll = false;

window.onscroll = doThisStuffOnScroll;

function doThisStuffOnScroll() {
    didScroll = true;
}

setInterval(function() {
    if(didScroll) {
        didScroll = false;
        if( jQuery(window).scrollTop() > 10 ){
            jQuery( '#top-bar-menu' ).addClass( 'sticky-scrolled' );
        }else{
            jQuery( '#top-bar-menu' ).removeClass( 'sticky-scrolled' );
        }
    }
}, 100);

jQuery( document ).ready( setupPage );
jQuery( window ).on( 'resize', setGridItemHeight );
